import { render, staticRenderFns } from "./bookbox.vue?vue&type=template&id=6a6832af&scoped=true&"
import script from "./bookbox.vue?vue&type=script&lang=js&"
export * from "./bookbox.vue?vue&type=script&lang=js&"
import style0 from "./bookbox.vue?vue&type=style&index=0&id=6a6832af&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6832af",
  null
  
)

export default component.exports